// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"sidebar_sidebarContainer__g0jSa","listContainer":"sidebar_listContainer__vE-Bg","list":"sidebar_list__kpsv4"};